import { z } from "zod";
import { zObjectId } from "../../utils";

export const zCartItemParameter = z.object({
  serviceId: zObjectId(),
  packageId: zObjectId(),
});
